import React from 'react';
import './Skills.css';

const Skills = ({image,name,type}) => {
  return (
    <div className='achievement'>
            <div className='circle'>
                <img src={image} alt='' />
                <span>{name}</span>
                <span>{type}</span>
            </div>
            
        </div>
  )
}

export default Skills